require('./mini-filter.less');

jQuery(function() {
    $('.js-btn-mini-filter').click(function(e) {
        e.preventDefault();
        var $this = $(this).addClass('mini-filter__btn--hidden');
        var $miniFilter = $this.closest('.mini-filter');
        $miniFilter.find('.mini-filter__content').addClass('mini-filter__content--visible');
    });
});



// WEBPACK FOOTER //
// ./blocks/mini-filter/mini-filter.js